import { createBrowserRouter, Outlet } from "react-router-dom";
import { Login } from "./login/login";
import { ProtectedView } from "../components/protected-view";
import { Recipe } from "./recipe/recipe";
import { RecipeZone } from "./recipe/recipe-zone";
import { Stores } from "./stores/stores";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedView />,
    children: [
      {
        path: "stores",
        element: <Stores />,
      },
      {
        path: "stores/:storeKey",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <RecipeZone />,
          },
          {
            path: ":zoneId",
            element: <Recipe />,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);
